var $window = $(window);
var breakPoint = 1024;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//SPヘッダーの開閉
import {spHeaderToggle} from "../include/module";
spHeaderToggle();

//外部ページからのアンカー
import {externalAnchor} from "../include/module";
externalAnchor();

//YouTubeのモーダル
import {youtubeModal} from "../include/module";
youtubeModal();

if(windowWidth > breakPoint){ // PCの幅の場合
} else { // SPの幅の場合
}

// $('.special-Detail_Body .content img').each(function(){
//   var tW = $(this).attr('width');
//   var tH = $(this).attr('height');
//   if(tW && tH){
//     $(this).css({width: tW, height: tH});
//   }
// });

$('.news-Detail_Body .content img').each(function(){
  var tW = $(this).attr('width');
  $(this).css({width: tW});
});


// WEBPACK FOOTER //
// ./src/assets/js/news/script.js